export default __webpack_public_path__ + "static/media/Mysore07.de24ce2e.jpg";